<template>
  <div class="qrCode-container">
    <el-card class="qrCode-content">
      <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="content" resize="none">
      </el-input>
    </el-card>
    <el-button class="generation-button" type="primary" @click="bindQRCode" :disabled="content===''">生成二维码</el-button>
    <el-card class="qrCode-generation">
      <div v-if="showDefaultQRCode" class="default-qrCode">
        此处生成二维码
      </div>
      <i v-else class="save-image el-icon-download" title="下载二维码" @click="downloadFile"></i>
      <div class="qrCode" ref="qrCodeDiv"></div>
    </el-card>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { getNumberName } from '@/common/utils/getHashName.js';
export default {
  name: 'generate-qrcode',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      content: '',
      showDefaultQRCode: true,
      qrCode: null,
      oldContent: ''
    }
  },
  mounted () {
    // 如果有资源路径
    if (this.url) {
      this.content = this.url;
      this.bindQRCode();
    }
  },
  watch: {
    url (val) {
      this.content = val;
      this.bindQRCode();
    }
  },
  methods: {
    // 生成二维码
    bindQRCode () {
      if (this.oldContent === this.content) {
        return this.$message.warning('生成二维码内容未发生改变！');
      }
      this.oldContent = this.content;
      this.showDefaultQRCode = false;
      // 如果有二维码，清除
      this.clear();
      this.qrCode = new QRCode(this.$refs.qrCodeDiv, {
        text: this.content,
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })

    },
    // 清除二维码
    clear () {
      if (this.qrCode) {
        this.$refs.qrCodeDiv.innerHTML = '';
        this.qrCode.clear();
        this.qrCode = null;
      }
    },
    // 下载二维码
    downloadFile () {
      if (!this.$refs['qrCodeDiv']) return;
      const url = this.$refs['qrCodeDiv'].children[1].getAttribute('src');
      let image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        let canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL(`image/png`);
        let a = document.createElement('a');
        let event = new MouseEvent('click');
        a.download = getNumberName(+new Date() + '');
        a.href = url;
        a.dispatchEvent(event);
      }
      image.src = url;
    },
  }
}
</script>

<style lang="scss" scoped>
.qrCode-container {
  display: flex;
  justify-content: space-between;
  .qrCode-content {
    width: 50%;
    text-align: center;
    .generation-button {
      margin-top: 20px;
    }
  }
  .qrCode-generation {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35%;
    height: 250px;
    .default-qrCode {
      height: 80px;
      line-height: 200px;
      color: #aaa;
      text-align: center;
      background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/qrcode.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 80px;
    }
    .save-image {
      position: absolute;
      font-size: 20px;
      font-weight: 600;
      bottom: 0;
      right: 0;
      cursor: pointer;
    }
  }
}
</style>